import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';

import queryMetaHandler from '../../../../utils/queryMetaHandler';
import omitProps from '../../../../utils/omitProps';
import { querySelector } from '../../../../utils';

import { LeaseInputLeaseFragment } from '../../../fields/LeaseInput';
import { OperatorInputOperatorFragment } from '../../../fields/OperatorInput';

const GetJobQuery = gql`
  query GetJob($jobId: Int!) {
    job(job_id: $jobId) {
      id
      job_number
      tickets {
        edges {
          node {
            id
            ticket_number {
              id
              number
              ticket {
                id
                state
                job {
                  id
                }
              }
            }
            well {
              id
              name
              lease {
                id
                name
              }
            }
          }
        }
      }
      lease {
        id
        lookup {
          ...LeaseInputLease
        }
        operator {
          id
          lookup {
            ...OperatorInputOperatorLookup
          }
        }
      }
    }
  }
  ${LeaseInputLeaseFragment}
  ${OperatorInputOperatorFragment}
`;

const mapDataToProps = withProps((props) => {
  const { job } = props.data;
  const tickets = querySelector(job, 'tickets.edges[*].node', []);
  return {
    job,
    tickets,
  };
});

export const querySingleJob = graphql(GetJobQuery);

export const QuerySingleJobGQL = compose(
  querySingleJob,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data']),
);
